import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { throttle, delay } from 'lodash';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import Image from '../../components/Image';
import PinchToZoom from '../../components/PinchToZoom';
import GigReview from '../../GigReview';

class ImageSlide extends PureComponent {

    constructor(props) {
        super(props);

        this.timerId = null;

        // Bindings
        this.showReview = this.showReview.bind(this);
        this.hideReview = this.hideReview.bind(this);
        this.flashReview = this.flashReview.bind(this);
        this.toggleReview = this.toggleReview.bind(this);
        this.throttledUpdateScrollStatus = throttle(this.updateScrollStatus.bind(this), 250);
        this.handleDimensions = this.handleDimensions.bind(this);

        // Refs
        this.wrapper = null;

        // Initial state
        this.state = {
            isLongImage: false,
            isShowingReview: false,
            isScrollable: false,
            hasBeenScrolled: false
        };
    }

    componentDidMount() {
        if (this.props.isActive) {
            this.flashReview();
        }
    }

    componentWillReceiveProps(nextProps) {
        this.hideReview();
        if (nextProps.isActive && !this.props.isActive) {
            this.flashReview();
        }
    }

    componentWillUnmount() {
        clearTimeout(this.timerId);
    }

    updateScrollStatus() {
        if (!this.wrapper) { return; }
        this.setState((prevState) => {
            if (!prevState.hasBeenScrolled) {
                return {
                    isScrollable: this.wrapper.scrollHeight > this.wrapper.offsetHeight,
                    hasBeenScrolled: this.wrapper.scrollTop > 5
                };
            }
        });
    }

    handleDimensions({width, height}) {
        const longAspectRatio = 1/1.5; // We consider an image with an aspect ration of 1:1.5 or taller a "Long image";
        const imageAspectRatio = width/height;
        if (imageAspectRatio <= longAspectRatio) {
            this.setState({isLongImage: true}, this.throttledUpdateScrollStatus);
        }
    }

    showReview(autohide) {
        const { slide: { review } } = this.props;
        if (!review) { return; }
        clearTimeout(this.timerId);
        this.setState({isShowingReview: true});
        if (autohide === true) {
            this.timerId = delay(this.hideReview, 4000);
        }
    }

    hideReview() {
        clearTimeout(this.timerId);
        this.setState({isShowingReview: false});
    }

    flashReview() {
        this.hideReview();
        this.timerId = delay(this.showReview, 200, true);
    }

    toggleReview() {
        if (this.state.isShowingReview) {
            this.hideReview();
        } else {
            this.showReview();
        }
    }

    render() {
        const {
            slide: { name, review, media },
            isActive,
            onClick,
            expanded,
            onZoomActive,
            onZoomIdle,
            preload
        } = this.props;

        const { isLongImage, isShowingReview, isScrollable, hasBeenScrolled } = this.state,
            figureClasses = classNames('thumbnail', {'long-image': isLongImage}),
            slideClasses = classNames(
                'slide',
                'slide-image',
                {
                    'active-review': isShowingReview && isActive,
                    'scroll-hint': isScrollable && !hasBeenScrolled && !isShowingReview
                }
            ),
            lazyLoad = !isActive && !preload,
            src = expanded ? media.original : media.medium;

        const thumbnail = (
            <figure className={figureClasses} tabIndex="0"
                ref={(node) => this.wrapper = node} onScroll={this.throttledUpdateScrollStatus}>
                <Image lazyLoad={lazyLoad} isActive={isActive}
                    alt={name} src={src} onDimensions={this.handleDimensions} onClick={this.toggleReview}/>
            </figure>
        );

        return (
            <div className={slideClasses} onClick={onClick}>
                {
                    expanded ?
                        <PinchToZoom rotate={false} minScale={1.5} onActive={onZoomActive}
                            onIdle={onZoomIdle} preventSingleTouchEvents={!isLongImage}>{thumbnail}</PinchToZoom>
                        : thumbnail
                }
                { review && <GigReview {...review} compact={!expanded}/> }
                { !expanded && <div className="slide-fullscreen">
                    <I18n k={'gig_page_perseus.gallery.full_screen'}/>
                </div> }
            </div>
        );
    }
}

ImageSlide.propTypes = {
    isActive: PropTypes.bool,
    slide: PropTypes.object,
    onClick: PropTypes.func,
    expanded: PropTypes.bool,
    onZoomActive: PropTypes.func,
    onZoomIdle: PropTypes.func,
    preload: PropTypes.bool
};

export default ImageSlide;
